// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2PXSL","footer":"ModalUpdate_footer__tFgz5"};